import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { projectsActions } from '../../actions';
import { DeleteChatActionPayload } from '../../typedefs';
import { PayloadActionWithPromiseMeta } from '@core/FinalForm/typedefs';
import { profileActions } from '@bus/profile/actions';

export function* deleteChat({
  payload,
  meta: { resolve, reject },
}: PayloadActionWithPromiseMeta<DeleteChatActionPayload>) {
  try {
    yield effects.put(projectsActions.startFetching());
    const response: Response = yield effects.apply(api, api.delete, [
      { endpoint: `chats/${payload.chat_id}` },
    ]);
    if (!response.ok) {
      reject();
      yield throwError(response);
    }

    yield effects.put(projectsActions.removeChat(payload.chat_id));
    yield effects.put(profileActions.removeChat(payload.chat_id));
    resolve();
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(projectsActions.stopFetching());
  }
}
